import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';
import InputAdornment from "@material-ui/core/InputAdornment";
import {Parts} from "components";

export default class Location extends Framework.Components.Object {
	constructor(props) {
		/**
		 *  @type {Locations_Object} this.state
		 */
		super(props, Types.Locations._name)
		this.state.parent = this.props.id;
	}

	form = () => {
		/**
		 * @param {Locations_Properties} data
		 */
		let {properties} = this.model;
		/**
		 *  @type {Locations_Object} object
		 */
		let object = this.state;
		const fflBossLinked = !!this.props.ffl_boss_linked;
		if(!fflBossLinked) {
			//float fflboss tax rate
			object.tax_rate_fflboss = parseFloat(object.tax_rate_fflboss);
		}

		return (
			<>
				<fieldset>
					<h4 className="section-title">Location</h4>
					<div className={"row"}>
						<div className={"col-md"}>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"name"}
									label={"Name"}
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"store_number"}
									label={"Store Number"}
									value={object.store_number}
									error={object.store_number_error}
									property={properties.store_number}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"description"}
									label={"Description"}
									property={properties.description}
									value={object.description}
									error={object.description_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									label={"Phone"}
									property={properties.phone}
									value={object.phone}
									error={object.phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-md"}>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								hasCounty={false}
							/>
						</div>
					</div>
					<hr/>
					<div className={"row"}>
						<div className={"col-md"}>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"tax_rate_state"}
									label={"State Tax Rate"}
									property={properties.tax_rate_state}
									value={object.tax_rate_state}
									error={object.tax_rate_state_error}
									type={'string'}
									update={this.handleTextFieldPropertyUpdate}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}> <i
												className="fa fa-percent"/></InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"tax_rate_special"}
									label={"Other/Special Tax Rate"}
									property={properties.tax_rate_special}
									value={object.tax_rate_special}
									error={object.tax_rate_state_error}
									update={this.handleTextFieldPropertyUpdate}
									type={"string"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}> <i
												className="fa fa-percent"/></InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>
						</div>
						<div className={"col-md"}>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"tax_rate_county"}
									label={"County Tax Rate"}
									property={properties.tax_rate_county}
									value={object.tax_rate_county}
									error={object.tax_rate_county_error}
									update={this.handleTextFieldPropertyUpdate}
									type={"string"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}> <i
												className="fa fa-percent"/></InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField

									label={"City Tax Rate"}
									property={properties.tax_rate_city}
									value={object.tax_rate_city}
									error={object.tax_rate_city_error}
									update={this.handleTextFieldPropertyUpdate}
									type={"string"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}> <i
												className="fa fa-percent"/></InputAdornment>
										),
										shrink: false
									}}

								/>
							</div>
						</div>
						<div className={"col-md"}>
							<div className="form-group">
								<Framework.Elements.TextField
									name={"credit_card_fee"}
									label={"Credit Card Fee"}
									property={properties.credit_card_fee}
									value={object.credit_card_fee}
									error={object.credit_card_fee_error}
									update={this.handleTextFieldPropertyUpdate}
									type={"string"}
									InputProps={{
										endAdornment: (
											<InputAdornment position={"end"}> <i
												className="fa fa-percent"/></InputAdornment>
										),
										shrink: false
									}}
								/>
							</div>
							{fflBossLinked && (
								<div className="form-group">
									<Framework.Elements.TextField
										name={"tax_rate_fflboss"}
										label={"FFLBoss product tax rate"}
										property={{...properties.tax_rate_fflboss, ignore_validation: true}}
										value={object.tax_rate_fflboss}
										error={object.tax_rate_fflboss_error}
										update={this.handleTextFieldPropertyUpdate}
										type={"string"}
										InputProps={{
											endAdornment: (
												<InputAdornment position={"end"}>
													<i className="fa fa-percent"/>
												</InputAdornment>
											),
											shrink: false
										}}
									/>
								</div>
							)}
						</div>
					</div>
				</fieldset>
				<div className={classNames("loader", {'active': this.state.loading})}>
					<ClipLoader color={"#4A4A4A"} loading={this.state.loading}/>
				</div>
			</>
		)
	}

}
